module.exports = {"data":[{"id":19,"user_id":"7olzwplk","support_pin":64672,"email":"ux@ooca.co","organization_id":"y137qeodzq8z82mknj0v","category1":{"data":{"id":91,"category":1,"name":"UX","created":1520244810}},"category2":null,"category3":null,"category4":null,"created":1516001174}],"meta":{"pagination":{"total":1,"count":1,"per_page":25,"current_page":1,"total_pages":1,"links":[]}}}


//////////////////
// WEBPACK FOOTER
// ./src/_mockup/individual_user.json
// module id = 1880
// module chunks = 0